import { ComponentType } from 'react';

import { HASTRA_VAULT_ID } from '@/app/shared/constants/web3/constants';
import { cn } from '@/app/shared/lib/cn';
import { PrimeLoopIcon } from '@/app/shared/svgComponents/PrimeLoopIcon';

const VAULT_ICONS_BY_ID: Record<string, ComponentType<{ className?: string }>> = {
  [HASTRA_VAULT_ID]: PrimeLoopIcon,
};

type VaultAvatarProps = {
  name?: string;
  vaultId?: string;
  className?: string;
};

const VaultAvatar = ({ vaultId, className }: VaultAvatarProps) => {
  const Icon = vaultId ? VAULT_ICONS_BY_ID[vaultId.trim().toLowerCase()] : undefined;

  if (Icon) {
    return <Icon className={cn('h-9 w-9 shrink-0', className)} />;
  }

  return <span className={cn('h-9 w-9 shrink-0 rounded-full bg-gray-900', className)} aria-hidden />;
};

export default VaultAvatar;
